import { render, staticRenderFns } from "./ScienceServiceList.vue?vue&type=template&id=571226c4&scoped=true&"
import script from "./ScienceServiceList.vue?vue&type=script&lang=js&"
export * from "./ScienceServiceList.vue?vue&type=script&lang=js&"
import style0 from "./ScienceServiceList.vue?vue&type=style&index=0&id=571226c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571226c4",
  null
  
)

export default component.exports